import type { ExamQuestion, GrammarLesson } from '../types';
import { coursePlanLessons } from './coursePlan';

const wrongByLevel = {
  Beginner: ['I is ready.', 'She are kind.', 'I can to repeat.'],
  A1: ['She do not likes tea.', 'Where you live?', 'I am go to school.'],
  A2: ['Did you went there?', 'I have saw it.', 'She must to leave.'],
  B1: ['If I will study, I pass.', 'The email wrote yesterday.', 'She said me the answer.'],
  B2: ['Despite of the problem, we continued.', 'The evidence are limited.', 'I am agree with this claim.'],
  C1: ['The data proves everyone is wrong.', 'This completely and absolutely solves the issue.', 'Rarely I have seen this.'],
} as const;

const question = (lesson: (typeof coursePlanLessons)[number], index: number, prompt: string, options: string[], answer: string, explanation: string): ExamQuestion => ({
  id: `g-${lesson.id}-q${index}`,
  type: 'choice',
  prompt,
  options,
  answer,
  explanation,
  level: lesson.level,
  topic: lesson.grammarFocus,
  explanationRu: lesson.level === 'Beginner' || lesson.level === 'A1' || lesson.level === 'A2'
    ? `Русское объяснение: ${lesson.ruSupport} Фокус грамматики: ${lesson.grammarFocus}.`
    : undefined,
});

export const grammarLessons: GrammarLesson[] = coursePlanLessons.map((lesson) => {
  const wrong = wrongByLevel[lesson.level];
  return {
    id: `g-${lesson.id}`,
    level: lesson.level,
    title: lesson.grammarFocus,
    explanationRu: `${lesson.ruSupport} Target grammar: ${lesson.grammarFocus}. Topic: ${lesson.topic}.`,
    examples: [
      lesson.example.en,
      lesson.level === 'Beginner' ? 'Please repeat the sentence slowly.' : `This pattern helps you discuss ${lesson.category} clearly.`,
      lesson.level === 'B2' || lesson.level === 'C1' ? `A precise answer should connect ${lesson.category} to evidence or implication.` : `I can make a short answer about ${lesson.category}.`,
    ],
    commonMistake: wrong[lesson.lessonNumber % wrong.length],
    practice: [
      question(lesson, 1, `Choose the correct ${lesson.level} sentence.`, [lesson.example.en, wrong[0], wrong[1]], lesson.example.en, `Use ${lesson.grammarFocus} accurately.`),
      question(lesson, 2, 'Choose the best rule for this lesson.', [`Use ${lesson.grammarFocus} to speak about ${lesson.category}.`, 'Ignore word order.', 'Use only Russian words.'], `Use ${lesson.grammarFocus} to speak about ${lesson.category}.`, lesson.ruSupport),
      question(lesson, 3, 'Which answer is too weak for this level?', [wrong[2], lesson.example.en, `I can explain ${lesson.category} with an example.`], wrong[2], `Avoid this common mistake: ${wrong[2]}`),
    ],
  };
});
